<!-- Divider -->
<div
    class="devstroupe-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
